export default [
  // *===============================================---*
  // *--------- 用户相关页面路由 -------------------------------*
  // *===============================================---*
  
  //用户登录
  {
    path: '/login',
    name: 'auth-login',
    component: () => import('@/views/users/user/Login.vue'),
    meta: {
      layout: 'full',
      resource: 'Auth',
      redirectIfLoggedIn: true,
    },
  },
  //用户列表
  {
    path: '/users/user/list',
    name: 'users-user-list',
    component: () => import('@/views/users/user/List.vue'),
	meta: {
	  pageTitle: 'User List',
	  breadcrumb: [
	    {
	      text: 'User List',
		  active: true,
	    },
	  ],
	},
  },
  //用户添加
  {
    path: '/users/user/add',
    name: 'users-user-add',
    component: () => import('@/views/users/user/Add.vue'),
	meta: {
	  pageTitle: 'Add User',
	  breadcrumb: [
	    {
	      text: 'User List',
		  to:'/users/user/list'
	    },
	    {
	      text: 'Add User',
	      active: true,
	    },
	  ],
	},
  },
  //用户修改
  {
    path: '/users/user/:name',
    name: 'users-user-edit',
    component: () => import('@/views/users/user/Edit.vue'),
  	meta: {
  	  pageTitle: 'Edit User',
  	  breadcrumb: [
  	    {
  	      text: 'User List',
  		  to:'/users/user/list'
  	    },
  	    {
  	      text: 'Edit User',
  	      active: true,
  	    },
  	  ],
  	},
  },
  //用户组列表
  {
    path: '/users/group/list',
    name: 'users-group-list',
    component: () => import('@/views/users/group/List.vue'),
	meta: {
	  pageTitle: 'Group List',
	  breadcrumb: [
	    {
	      text: 'Group List',
		  active: true,
	    },
	  ],
	},
  },
  //新增用户组
  {
    path: '/users/group/add',
    name: 'users-group-add',
    component: () => import('@/views/users/group/Add.vue'),
	meta: {
	  pageTitle: 'Add Group',
	  breadcrumb: [
	    {
	      text: 'Group List',
		  to:'/users/group/add'
	    },
	    {
	      text: 'Add Group',
	      active: true,
	    },
	  ],
	},
	
  },
  //修改用户组
  {
    path: '/users/group/:name',
    name: 'users-group-edit',
    component: () => import('@/views/users/group/Edit.vue'),
  	meta: {
  	  pageTitle: 'Edit Group',
  	  breadcrumb: [
  	    {
  	      text: 'Group List',
  		  to:'/users/group/add'
  	    },
  	    {
  	      text: 'Edit Group',
  	      active: true,
  	    },
  	  ],
  	},
  }

]
